import React from 'react'
import ItemPieceErrorPage from './ItemPieceErrorPage'
import '../styles/index.scss'

function ItemPieceErrorContainer() {
    return (
        <div className='ItemPieceErrorContainer'>
            <ItemPieceErrorPage />
        </div>
    )
}

export default ItemPieceErrorContainer